import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class DefaultVideo extends PureComponent {
    static propTypes = {
        videoUrl: PropTypes.string.isRequired,
        dimensions: PropTypes.object.isRequired,
    };

    render() {
        return (
            <iframe
                frameBorder="0"
                height={this.props.dimensions.h}
                src={this.props.videoUrl}
                width={this.props.dimensions.w}
            />
        );
    }
}

export default DefaultVideo;
